import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

import BillContent from "./BillContent";

const PrintBillModal = ({ order, isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: order ? `invoice - ${order.billNo}` : "invoice",
    onAfterPrint: () => setIsOpen(false),
  });

  return (
    <Modal
      title={t("common.printInvoice")}
      centered
      open={isOpen}
      okText={t("common.print")}
      cancelText={t("common.cancle")}
      onOk={handlePrint}
      onCancel={() => setIsOpen(false)}
      maskClosable={false}
      width={1100}
    >
      {order && (
        <div ref={componentRef}>
          <BillContent order={order} />
        </div>
      )}
    </Modal>
  );
};

export default PrintBillModal;
